/**
 * 商品管理
 */
import { GOODSMANAGE } from '../types';

export default {
    name: `${GOODSMANAGE}`,
    path: '/goodsManage',
    component: () => import(/* webpackChunkName: 'goodsManage' */ '@/views/goodsManage/'),
    redirect: { name: `${GOODSMANAGE}Index` },
    meta: {
        title: '商品管理',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${GOODSMANAGE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'goodsManage' */ '@/views/goodsManage/home/Home.vue'),
        },
        {
            name: `${GOODSMANAGE}Create`,
            path: 'Create',
            component: () => import(/* webpackChunkName: 'goodsManage' */ '@/views/goodsManage/add/Add.vue'),
        },
        {
            name: `${GOODSMANAGE}Detail`,
            path: 'detail',
            component: () => import(
                    /* webpackChunkName: 'goodsManage' */ '@/views/goodsManage/detail/Detail.vue'
                ),
        },
    ],
};
